import * as React from 'react'

import EnhancedLazyLoad from '../../../components/enhancedLazyLoad'
import ImagePlaceholder from '../../imagePlaceholder'

import * as styles from './defaultItemPreviewer.module.css'

const DefaultItemPreviewer = ({
  url,
  imageUrl,
  onClick,
  name,
  isSquareImage,
  lazyLoad = false
}: {
  url: string
  name: string
  imageUrl: string
  onClick?: () => void
  isSquareImage?: boolean
  lazyLoad?: boolean
}) => {
  const imgClassName = isSquareImage ? styles.img : ''
  return (
    <a href={url} onClick={onClick} aria-label={name}>
      <EnhancedLazyLoad
        disabled={!lazyLoad}
        placeholder={<ImagePlaceholder width={80} height={80} />}
      >
        <img alt={name} className={imgClassName} src={imageUrl} />
      </EnhancedLazyLoad>
    </a>
  )
}
export default DefaultItemPreviewer
